export type SecondFactorEnrollmentRequiredAction = {
	type: 'SECOND_FACTOR_ENROLLMENT_REQUIRED';
};

export default (): SecondFactorEnrollmentRequiredAction => ({
	type: 'SECOND_FACTOR_ENROLLMENT_REQUIRED',
});
